import { Component, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { AccountService } from 'src/app/services/account.service';
import { IVerificationInterface, emptyVerificationInterface } from 'src/app/shared/models/verification.interface';
import { PolicyService } from 'src/app/services/policy.service';
import { Router } from '@angular/router';
import { PolicyEventService } from 'src/app/services/policy-event.service';
import { Title } from '@angular/platform-browser';
import { ALPHA_NUMERIC_AND_SPACES_PATTERN } from 'src/app/shared/regex-patterns';
import { environment } from 'src/environments/environment';
import { PolicyFormatService } from 'src/app/services/policy-format.service';

@Component({
  selector: 'upsc-add-policy',
  templateUrl: './add-policy.component.html',
  styleUrls: ['./add-policy.component.scss']
})

export class AddPolicyComponent {
  private policyLimit: number = 10;
  public currentStep = 1;
  public policyFormGroup: UntypedFormGroup;

  isCanadaUser: boolean;
  isUkUser: boolean;
  isUsaUser: boolean;
  isGermanyUser: boolean;
  isFranceUser: boolean;
  isItalyUser: boolean;

  userDetails: any;
  scriptError: boolean;
  errorReturned: boolean;
  apiInProgress: boolean;
  systemError: boolean;
  invalidVerificationCode: boolean = false;

  app_Role_ID: string = '';
  claim_Notification: boolean = false;
  groupId: number = 0;
  shipperNumber: string = '00000';
  parentPolicy: boolean = false;
  invalidPolicy: boolean = false;
  emailAddress: string = '';
  policyDetails: any;
  parentPolicyNumber: string = '';
  parentPolicyError: boolean = false;
  duplicateChildPolicy: boolean = false;

  public createVerificationInterface: IVerificationInterface = emptyVerificationInterface;

  constructor(private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private accountService: AccountService,
    private policyService: PolicyService,
    private policyEventService: PolicyEventService,
    private titleService: Title,
    private policyFormatService: PolicyFormatService 
  ) {
    this.titleService.setTitle('Add New Policy');
    this.setUserInfo();
    this.setAppRoleIdNClaimsNotification();
    this.setpolicyFormGroupInfo();
  }

  setUserInfo() {
    this.isCanadaUser = this.userService.isCanadaUser();
    this.isUkUser = this.userService.isUkUser();
    this.isUsaUser = this.userService.isUsaUser();
    this.isGermanyUser = this.userService.isGermanyUser();
    this.isFranceUser = this.userService.isFranceUser();
    this.isItalyUser = this.userService.isItalyUser();
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    this.policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    if (this.policyDetails) {
      this.parentPolicyNumber = this.policyDetails.policyNumber;
    }
  }

  setpolicyFormGroupInfo() {
    //this.userDetails.emailAddress : '15914024-P0004050' '11201'
    this.policyFormGroup = this.formBuilder.group({
      policyNumberFormControl: ['', [Validators.required, Validators.minLength(6)]],
      emailFormControl: [{ value: this.userDetails.emailAddress, disabled: true }, Validators.compose([Validators.required, Validators.email])],
      zipFormControl: ['', [Validators.required, Validators.pattern(ALPHA_NUMERIC_AND_SPACES_PATTERN)]],
    });
  }

  setAppRoleIdNClaimsNotification() {
    var userInfo = this.userService.getUserInfo();
    this.app_Role_ID = this.userService.hasClaimsManagerRole() ? 3 : this.userService.hasClaimsFilerRole() ? 4 : userInfo.userRoleID === null ? 0 : userInfo.userRoleID;
    this.groupId = userInfo.groupID === null ? 0 : userInfo.groupID;
    this.shipperNumber = userInfo.shipperNumber === null ? '00000' : userInfo.shipperNumber;
    this.claim_Notification = false;
  }

  public onSubmit() {

    var policyNumber = this.policyFormGroup.get('policyNumberFormControl').value.trim();
    var zipCode = this.policyFormGroup.get('zipFormControl').value.trim();

    if (this.policyFormGroup.valid) {

      //claim managers and claim filers of WWE can only add policies from pre-defined policies
      if((this.userService.hasClaimsManagerRole() || this.userService.hasClaimsFilerRole()) && (!environment.expandedTogglePolicies || environment.expandedTogglePolicies.indexOf(policyNumber) < 0)) {
        this.invalidPolicy = true;
        return false;
      }
      //stop tupss contracts from being added
      if(policyNumber.startsWith('623876-')) {
        this.invalidPolicy = true;
        return false;
      }

      var childPolicies = this.policyEventService.getChildPolicies();
      if (this.parentPolicyNumber === policyNumber) {
        this.parentPolicyError = true;
        return false;
      }
      else if (childPolicies !== undefined && childPolicies.length > 0) {

        var childPolicy = childPolicies.find(x => x === policyNumber);
        if (childPolicy) {
          this.duplicateChildPolicy = true;
          return false;
        } else {
          this.duplicateChildPolicy = false;
          this.checkPolicy(policyNumber, zipCode);
        }
      } else {
        this.checkPolicy(policyNumber, zipCode);
      }
    }
    return false;
  }

  checkPolicy(policyNumber, zipCode) {
    this.accountService.policyCheck(policyNumber, zipCode).subscribe(
      data => {
        if (data) {
          this.emailAddress = this.policyFormGroup.get('emailFormControl').value;
          this.scriptError = false;
          this.invalidPolicy = false;
          this.systemError = false;
          this.parentPolicyError = false;
          this.addPolicy();
        } else {
          this.errorReturned = true;
          this.apiInProgress = false;
          this.invalidPolicy = true;
          this.systemError = false;
          this.parentPolicyError = false;
        }
      }, error => {
        if ((error.error != null && error.error.errorMessage !== undefined) && ((error.error.errorMessage === 'InvalidInput for field/s.') || (error.error.errorMessage === 'Invalid Input'))) {
          this.scriptError = true;
        }
        else {
          this.systemError = true;
          this.apiInProgress = false;
        }
      }
    );
  }

  cancelFromVerification() {
    this.currentStep = 1;
  }

  policyError: boolean = false;
  addPolicy() {
    let policyCount = 0;
    if (sessionStorage.getItem("PolicyCount") !== null) {
      policyCount = Number(sessionStorage.getItem("PolicyCount"));
    }

    var childPolicies = this.policyEventService.getChildPolicies();
    if (childPolicies !== undefined && childPolicies) {
      let policy = childPolicies.find(x => x == this.policyFormGroup.get('policyNumberFormControl').value.trim());
      if (policy !== undefined && policy.length > 1) {
        this.policyError = true;
      }
    }

    if (policyCount <= this.policyLimit && !this.policyError) {
      let request = {
        docId: 0,
        userID: Number(this.userDetails.userId),
        policyNumber: this.policyFormGroup.get('policyNumberFormControl').value.trim(),
        modifiedBy: 0,
        policyZip: this.policyFormGroup.get('zipFormControl').value.trim(),
        approve: 1,
        active: 0,
        groupId: this.groupId === null ? 0 : this.groupId,
        nickName: this.userDetails.contactName,
        shipperNumber: this.shipperNumber,
        appRoleId: Number(this.app_Role_ID),
        claimNotifications: this.claim_Notification === true ? 1 : 0,
        PolicyHolderName: '',
        ShipperName: '',
        emailAddress: this.userDetails.emailAddress, //the email of currently logged in user
        countryLocale: sessionStorage.getItem('locale'),
      };

      this.policyService.addNewPolicy(request).subscribe(
        data => {
          if (data) {
            sessionStorage.setItem("UserPolicyDetails", "0");
            this.policyEventService.subjectAdded('Added new policy:' + request.policyNumber);
            this.currentStep = 2;
          }
        },
        error => {
          this.systemError = true;
        }
      );
    }
  }

  formatPolicy() {
    var policyNumber = this.policyFormGroup.controls.policyNumberFormControl.value;
    this.policyFormGroup.controls.policyNumberFormControl.setValue(this.policyFormatService.formatPolicy(policyNumber));
  }

}
